// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNav-cls1_WWr","cls2":"FocusedNav-cls2_muy FocusedNav-cls1_WWr"};